export interface PricingRow {
  key: string;
  categoryName: string;
  listPrice: number | '';
  campaignDiscount: number | ''; // e.g. 0.45 for 45%
  extraDiscount: number | ''; // e.g. 0.05 for 5%
  vatRate: number | ''; // e.g. 0.10 for 10%
  isManual?: boolean; // Kullanıcının eklediği serbest satır (adı düzenlenebilir, silinebilir)
}

export interface ComputedPricingRow extends PricingRow {
  displayName: string;
  campaignPrice: number;
  incVatPrice: number;
}

export interface PricingCalculations {
  rows: ComputedPricingRow[];
  listGrandTotal: number;
  campaignSavings: number;
  netGrandTotal: number;
  totalVat: number;
  finalTotal: number;
}

export const MANUAL_ROW_FALLBACK_NAME = 'Ek Kalem';
export const MAX_MANUAL_ROWS = 6; // PDF'de Proje Özeti sayfasının taşmaması için üst sınır

/**
 * Calculates the totals and item breakdown for the kitchen proposal
 */
export function calculatePricing(
  pricingRows: PricingRow[],
  resolvedModelName: string
): PricingCalculations {
  let listGrandTotal = 0;
  let netGrandTotal = 0;
  let totalVat = 0;
  let campaignSavings = 0;

  const computedRows = pricingRows.map(row => {
    const displayName = row.key === 'model_cabinets'
      ? `${resolvedModelName} Mutfak Dolapları`
      : row.isManual
        ? (row.categoryName.trim() || MANUAL_ROW_FALLBACK_NAME)
        : row.categoryName;
    const valListPrice = row.listPrice === '' ? 0 : row.listPrice;
    const valCampaignDiscount = row.campaignDiscount === '' ? 0 : row.campaignDiscount;
    const valExtraDiscount = row.extraDiscount === '' ? 0 : row.extraDiscount;
    const valVatRate = row.vatRate === '' ? 0 : row.vatRate;

    const campaignPrice = valListPrice * (1 - valCampaignDiscount) * (1 - valExtraDiscount);
    const vatAmount = campaignPrice * valVatRate;
    const incVatPrice = campaignPrice + vatAmount;

    listGrandTotal += valListPrice;
    netGrandTotal += campaignPrice;
    totalVat += vatAmount;
    campaignSavings += (valListPrice - campaignPrice);

    return {
      ...row,
      displayName,
      campaignPrice,
      incVatPrice
    };
  });

  const finalTotal = netGrandTotal + totalVat;

  return {
    rows: computedRows,
    listGrandTotal,
    campaignSavings,
    netGrandTotal,
    totalVat,
    finalTotal
  };
}

/**
 * Helper to format a number into Turkish currency formatting
 */
export const formatNumber = (val: number | string): string => {
  if (val === '' || val === undefined || val === null) return '-';
  const num = typeof val === 'string' ? parseFloat(val) : val;
  if (isNaN(num)) return '-';
  return Math.round(num).toLocaleString('tr-TR');
};

/**
 * Helper to format a number with the TL currency suffix
 */
export const formatTL = (val: number | string): string => {
  if (val === '' || val === undefined || val === null) return '-';
  const num = typeof val === 'string' ? parseFloat(val) : val;
  if (isNaN(num)) return '-';
  return `${Math.round(num).toLocaleString('tr-TR')} TL`;
};
